$(document).on('ready', function(){
    var _loadScript = function(src,callback){
        var script = document.createElement("script");
        script.type = "text/javascript";
        //if(callback)script.onload=callback;
        document.getElementsByTagName("head")[0].appendChild(script);
        script.src = src;
    };
    var _onGmapsLoaded = function(e){
        _initMap();
    };


    function _initMap() {
        if($('#map').length == 0)return;
        var customMapType = new google.maps.StyledMapType([{"stylers":[{"saturation":-100},{"gamma":1}]},{"elementType":"labels.text.stroke","stylers":[{"visibility":"off"}]},{"featureType":"poi.business","elementType":"labels.text","stylers":[{"visibility":"off"}]},{"featureType":"poi.business","elementType":"labels.icon","stylers":[{"visibility":"off"}]},{"featureType":"poi.place_of_worship","elementType":"labels.text","stylers":[{"visibility":"off"}]},{"featureType":"poi.place_of_worship","elementType":"labels.icon","stylers":[{"visibility":"off"}]},{"featureType":"road","elementType":"geometry","stylers":[{"visibility":"simplified"}]},{"featureType":"water","stylers":[{"visibility":"on"},{"saturation":50},{"gamma":0},{"hue":"#50a5d1"}]},{"featureType":"administrative.neighborhood","elementType":"labels.text.fill","stylers":[{"color":"#333333"}]},{"featureType":"road.local","elementType":"labels.text","stylers":[{"weight":0.5},{"color":"#333333"}]},{"featureType":"transit.station","elementType":"labels.icon","stylers":[{"gamma":1},{"saturation":50}]}],
            {
                name: 'Custom Style'
            });
        var point = {lat: parseFloat($('#map').attr('data-lat')), lng: parseFloat($('#map').attr('data-lng'))};

        var customMapTypeId = 'custom_style';
        var isDraggable = !('ontouchstart' in document.documentElement);
        var map = new google.maps.Map(document.getElementById('map'), {
            zoom: parseFloat($('#map').attr('data-zoom')), center: point,
            scrollwheel:  false, draggable: isDraggable,
            /*disableDefaultUI: true, mapTypeControlOptions: {
                mapTypeIds: [google.maps.MapTypeId.ROADMAP, customMapTypeId]
            }*/
        });

        var image = {
            url: $('#map').attr('data-imgmarker'),
            size: new google.maps.Size(50, 50),
            scaledSize: new google.maps.Size(50, 50),
            origin: new google.maps.Point(0, 0),
            anchor: new google.maps.Point(25, 50)
        };

        var wnpMarker = new google.maps.Marker({
            position: point,
            map: map,
            icon: image,
            size: new google.maps.Size(20, 32),
        });

        //map.mapTypes.set(customMapTypeId, customMapType);
        //map.setMapTypeId(customMapTypeId);
    } ;
    $(window).on('gmapLoaded', _onGmapsLoaded);
    _loadScript('https://maps.googleapis.com/maps/api/js?v=3&sensor=false&callback=initializeGmaps&key=AIzaSyDWjSmhx9UPo6LriMqVZ7xndlhmf4cCPYM');
});